import { takeEvery } from 'redux-saga/effects';

import * as payoutActions from 'store/modules/payouts';
import { validateDialogFieldValue } from './utils';

export default function* listenSetDialogFieldValue() {
  yield takeEvery(payoutActions.setDialogFieldValue.toString(), validateDialogFieldValue);
}
